import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import "../styles/Header.css";
import anavuLogo from "../images/iiit_logo.png";
import videoIcon from "../images/video_icon.svg";
import screenIcon from "../images/screen_icon.svg";
import searchIcon from "../images/search_icon.svg";
import userIcon from "../images/user_icon.png";
import logoutIcon from "../images/logoutIcon.png"; // Import your logout icon here
import { getName, setToken, setName, setUserID } from "../Storage/Storage"; // Import storage functions

const Header = ({
  isVideoMode,
  toggleMode,
  showSearch,
  showToggle,
  showUserProfile,
  onSearch,
  searchQuery,
}) => {
  const [name, setNameState] = useState("");
  const [showLogout, setShowLogout] = useState(false); // State to show/hide logout button
  const navigate = useNavigate(); // Initialize useNavigate for redirection

  useEffect(() => {
    const fetchName = async () => {
      try {
        const userName = await getName();
        setNameState(userName);
      } catch (error) {
        console.error("Failed to fetch name", error);
      }
    };
    fetchName();
  }, []);

  const handleSearch = (event) => {
    const query = event.target.value;
    onSearch(query); // Pass the query to the parent component
  };

  const handleLogout = async () => {
    // Clear the token and other user data from localStorage
    try {
      await setToken(""); // Clear token
      await setName(""); // Clear name
      await setUserID(""); // Clear user ID
      console.log("User logged out");

      // Navigate to the landing page after logout
      navigate("/");
    } catch (error) {
      console.error("Error logging out", error);
    }
  };

  return (
    <header className="header">
      <div className="logo-container">
        <a href="/">
          <img src={anavuLogo} alt="Anavu Logo" className="logo" />
          <div className="logo-text">Anavu</div>
        </a>
      </div>

      {showSearch && (
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery} // Use searchQuery passed from LearnerDashboard
            onChange={handleSearch} // Update the search query
          />
          <button className="search-button">
            <img src={searchIcon} alt="Search" />
          </button>
        </div>
      )}

      <div className="mode-toggle">
        {showToggle && (
          <>
            <button
              onClick={() => toggleMode(true)}
              className={`toggle-button ${isVideoMode ? "active" : ""}`}
            >
              <img src={videoIcon} alt="Video Mode" />
            </button>
            <button
              onClick={() => {}}
              className={`toggle-button ${!isVideoMode ? "active" : ""}`}
              disabled
              title="Under Development"
            >
              <img src={screenIcon} alt="Screen Mode" />
            </button>
          </>
        )}
      </div>

      <div className="header-user-profile">
        {showUserProfile && (
          <>
            <div className="header-user-name">{name || "Loading..."}</div>
            <img
              src={userIcon}
              alt="User Icon"
              className="header-user-icon"
              onClick={() => setShowLogout(!showLogout)} // Toggle logout button visibility
              style={{ cursor: "pointer" }} // Add pointer cursor for user icon
            />
            {showLogout && (
              <button className="logout-button" onClick={handleLogout}>
                <div className="logout-icon">
                  <img src={logoutIcon} alt="Logout Icon" className="logout-icon" />
                </div>
                <div className="logout-text">Logout</div>
              </button>
            )}
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
